<template>
    <div class="tile is-3" @click="$emit ('catalog-select', id)">
        <div class="card" v-bind:class="{ 'has-background-warning': highligh }">
            <header class="card-header">
                <p class="card-header-title">
                    {{ label.val}}
                </p>
                {{ translatedTrUnits }} / {{ totalTrUnits }}
            </header>
            <div class="card-image" v-if="image.val">
                <figure class="image is-128x128">
                    <img :src="image.val" :alt="name.val">
                </figure>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState }         from 'vuex'

export default {
    name: "CatalogListEntry",
    props: {
        id:     {type: String, required: true},
        label:  {type: Object},
        name:   {type: Object},
        image:  {type: Object},
        t9n:    Boolean,
        t9n_tags: Array
    },
    computed: {
        ...mapState ("translation", {
            targetLang:  state => state.targetLang,
            sourceLang:  state => state.sourceLang,
            languages:   state => state.languages,
        }),
        translatedTrUnits () {
            let translated = 0
            const trLang = this.languages [this.targetLang] [1]
            for (const key of this.t9n_tags) {
                if (key in trLang) translated += 1
            }
            return translated
        },
        totalTrUnits () {
            return this.t9n_tags.length
        },
        highligh () { return this.totalTrUnits != this.translatedTrUnits }
    }
}
</script>

<style>

</style>